"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.minHeightBreakpoint = exports.minWidthBreakpoint = exports.breakpointValues = void 0;

var _styledComponents = require("styled-components");

var breakpointValues = {
  hd: 1920,
  sd: 1366,
  cs: 1190,
  tablet: 1024,
  tabletPortrait: 800,
  phoneLarge: 680,
  phone: 500
};
exports.breakpointValues = breakpointValues;
var minWidthBreakpoint = Object.keys(breakpointValues).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(["@media (min-width:", "em){", "}"], (breakpointValues[label] + 1) / 16, _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
exports.minWidthBreakpoint = minWidthBreakpoint;
var minHeightBreakpoint = Object.keys(breakpointValues).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(["@media (min-height:", "em){", "}"], breakpointValues[label] / 16, _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
exports.minHeightBreakpoint = minHeightBreakpoint;

var _default = Object.keys(breakpointValues).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(["@media (max-width:", "em){", "}"], breakpointValues[label] / 16, _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});

exports.default = _default;